module.exports = __webpack_public_path__ + "img/94.98b2650f.jpg";